<template>
  <div class="flex justify-start items-start mx-auto w-full max-w-7xl mb-5" :class="isSidebarOpen ? 'mt-5' : 'mt-[20%] sm:mt-[25%] md:mt-[16%] lg:mt-[10%] xl:mt-[7%]'" id="titre">
    <h1 class="font-cursive text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight text-gray-900 text-left pl-2 sm:pl-0 sm:mb-12">
      <span class="inline text-navigation">{{ textePrincipal }}</span>
      <span class="text-primaire inline">{{ texteAccentue }}</span>
    </h1>
  </div>
</template>

<script>
export default {
  name: 'Titre',
  props: {
    textePrincipal: {
      type: String,
      required: true,
    },
    texteAccentue: {
      type: String,
      required: true,
    },
    isSidebarOpen: {
      type: Boolean,
      required: true,
    },
  },
};
</script>